import { render, staticRenderFns } from "./yuhang.vue?vue&type=template&id=1f4e70e8&scoped=true&"
import script from "./yuhang.vue?vue&type=script&lang=js&"
export * from "./yuhang.vue?vue&type=script&lang=js&"
import style0 from "./yuhang.vue?vue&type=style&index=0&id=1f4e70e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e70e8",
  null
  
)

export default component.exports